// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "companies-frontend-b21b3468/chunk-" + "1ab2d8feea3ce668" + ".js";
};